export function diffDays(a: string, b: string): number {
  return Math.max(
    0,
    Math.round((new Date(b).getTime() - new Date(a).getTime()) / 86400000),
  );
}

export function formatDate(dateString: string | Date): string {
  const date =
    typeof dateString === "string" ? new Date(dateString) : dateString;

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
    .format(date)
    .replace(",", "");
}

export function relativeTimeFromNow(dateInput: string | Date): string {
  const targetDate = new Date(dateInput).getTime();
  const now = Date.now();
  const diff = targetDate - now;

  if (diff <= 0) return "expired";

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) return `${years} year${years > 1 ? "s" : ""} left`;
  if (months > 0) return `${months} month${months > 1 ? "s" : ""} left`;
  if (days > 0) return `${days} day${days > 1 ? "s" : ""} left`;
  if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} left`;
  if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} left`;
  return `${seconds} second${seconds !== 1 ? "s" : ""} left`;
}

export function dueRelativeDate(dateInput: string | Date): string {
  const targetDate = new Date(dateInput).getTime();
  const now = Date.now();
  const diff = targetDate - now;

  if (diff <= 0) return "Due date passed";

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);

  if (weeks > 0) return `${weeks} Week${weeks > 1 ? "s" : ""} until Due`;
  if (days > 0) return `${days} Day${days > 1 ? "s" : ""} until Due`;
  if (hours > 0) return `${hours} Hour${hours > 1 ? "s" : ""} until Due`;
  if (minutes > 0)
    return `${minutes} Minute${minutes > 1 ? "s" : ""} until Due`;
  return `${seconds} Second${seconds !== 1 ? "s" : ""} until Due`;
}

export function subscriptionState(
  endDate: string | Date,
): "warning" | "critical" | "expired" | "ok" {
  const today = new Date();
  const end = typeof endDate === "string" ? new Date(endDate) : endDate;
  const daysLeft = diffDays(today.toISOString(), end.toISOString());

  if (daysLeft <= 0) return "expired";
  if (daysLeft <= 14) return "critical";
  if (daysLeft <= 30) return "warning";
  return "ok"; // optional, for more than 30 days
}
